import React, { useState } from "react";
import { EditorContext } from "components/Editor";
import { useWidgetChildrenSelector } from "components/Editor/hooks/useEditorSession";
import { useDispatch, useSelector } from "react-redux";
import { updateWidgetProperty } from "actions/editor";


import _ from "lodash";

export const Container = React.memo(({widgetProps, widgetRef, children }) => {
  const editorContext = React.useContext(EditorContext);
  
  React.useEffect(() => {
    if(widgetRef.current){
      editorContext.editorSession.moveableData.addContainer(widgetRef.current);
    }

    return () => {
      if(widgetRef.current){
        editorContext.editorSession.moveableData.removeContainer(widgetRef.current);
      }
    }
  }, []);

  return children;
});